import { useEffect, useState } from "react";

import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import useCommunicationSettings from "common/datahooks/useCommunicationSettings";
import usePushService from "common/hooks/usePushService";

import WebPushNotificationsImage from "assets/images/web-push-notifications.png";

export default function WebPushPrompt() {
  const { webPushPrompted, subscribeWebPush, updateLocalStorage } =
    usePushService();
  const { communicationSettings } = useCommunicationSettings();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (communicationSettings?.webpush) {
      if (!webPushPrompted) {
        navigator.permissions
          .query({ name: "notifications" })
          .then(({ state }) => {
            setIsOpen(state !== "granted");
            updateLocalStorage(true);
          });
      }
      subscribeWebPush()
        .then(() => {
          setIsOpen(false);
        })
        //ignore error
        .catch(() => {});
    }
  }, [communicationSettings, webPushPrompted]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent>
        <DialogHeader
          title="Enable Web Push Notifications"
          subtitle="Please enable Web Push notifications to receive the latest updates and offers from Aimfox"
          imgSrc={WebPushNotificationsImage}
        />
        <DialogFooter className="justify-center text-sm-bold text-purple-500">
          Press “ALLOW” in the browser prompt
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
